(function ($) {


const Init = (() => {

  // settings
  
  
  let website      = {},
      load         = {},
      resize       = {},
      scroll       = {},
      mod          = {},
      scrollOption = {},
      parallax     = {},
      drawer       = {},
      navi         = {},
      form         = {},
      formMethod   = {},
      timer        = {},
      wp           = {},
      iscroll      = {},
      loading      = {},
      totop        = {},
      scrollbar    = {},
      canvas       = {},
      tab          = {},
      favorite     = {},
      accordion    = {},
      megamenu     = {};
  
  website = {
    page          : document.body.dataset.page,
    url           : document.URL,
    winWidth      : window.innerWidth,
    winHeight     : window.innerHeight,
    scrollY       : window.pageYOffset,
    breakpoint    : { pc: 1200, tb: 992, sp: 768, ss: 576 },
    ua            : navigator.userAgent.toLowerCase(),
    isDesktop     : true,
    isFirst       : true,
    animationFrame: null,
  
    headTag       : $('.l-header'),
  
    act           : 'is-act',
    actOpen       : 'is-open',
  
    targetAnime : 'js-anime',
    actAnime    : 'is-anime',
    shiftPoint  : 0,
    shiftPc     : 5,
    shiftSp     : 10,
  };
  website.shiftPoint = website.breakpoint.tb;
  
  page ={
    top : [],
    contact : []
  };
  
  load = {
    functions: [],
    length   : 0,
  };
  
  resize = {
    functions: [],
    length   : 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  scroll = {
    functions: [],
    length   : 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  

  //modules
  // サニタイズ関数
  function sanitizing(str){
    var before = new Array('&','"',"'","<",">","\n","\t","\\n");
    var after = new Array('&amp;','&quot;','&rsquo;',"&lt;","&gt;","<br />"," ","<br />");
    for( var i=0; i < before.length; i++ )
      str = str.replace(new RegExp(before[i],'g'), after[i]);
    return str;
  };
  
  // LOAD
  const WinLoad = {
  
    init() {
      window.addEventListener('load', function(e) {
        WinLoad.update();
      });
  
      console.log('!-- load init --!');
    },
  
    add(func) {
      load.functions.push(func);
      load.length = load.functions.length;
    },
  
    remove(func) {
      load.functions.splice(func, 1);
      load.length = load.functions.length;
    },
  
    update() {
      for ( let i = 0; i < load.length; i++ ) {
        let func = load.functions[i];
        func();
      }
    },
  
  }
  
  // RESIZE
  const WinResize = {
  
    init() {
      window.addEventListener('resize', function(e) {
        if ( !resize.isRunning ) {
          resize.isRunning = true;
  
          resize.animationFrame = window.requestAnimationFrame( WinResize.update );
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinResize.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinResize.update();
          //   }, 1000/resize.fps);
          // }
        }
      });
  
      console.log('!-- resize init --!');
    },
  
    add(func) {
      resize.functions.push(func);
      resize.length = resize.functions.length;
    },
  
    remove(func) {
      resize.functions.splice(func, 1);
      resize.length = resize.functions.length;
    },
  
    update() {
      website.winWidth  = window.innerWidth;
      website.winHeight = window.innerHeight;
      website.ua        = navigator.userAgent.toLowerCase();
  
      for ( let i = 0; i < resize.length; i++ ) {
        let func = resize.functions[i];
        func();
      }
  
      resize.isRunning = false;
    },
  
  }
  
  // SCROLL
  const WinScroll = {
  
    init() {
      window.addEventListener('scroll', function(e) {
        if ( !scroll.isRunning ) {
          scroll.isRunning = true;
  
          scroll.animationFrame = window.requestAnimationFrame( WinScroll.update );
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinScroll.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinScroll.update();
          //   }, 1000/scroll.fps);
          // }
        }
      });
  
      console.log('!-- scroll init --!');
    },
  
    add(func) {
      scroll.functions.push(func);
      scroll.length = scroll.functions.length;
    },
  
    remove(func) {
      scroll.functions.splice(func, 1);
      scroll.length = scroll.functions.length;
    },
  
    update() {
      website.winHeight = window.innerHeight;
      website.scrollY = window.pageYOffset;
  
      for ( let i = 0; i < scroll.length; i++ ) {
        let func = scroll.functions[i];
        func();
      }
  
      scroll.isRunning = false;
    },
  
  }
  
  
  const Modules = {
  
    init() {
      mod = {
        targetSmooth    : 'js-scroll',
        targetTotop     : 'js-totop',
        smoothSpeed     : 600,
  
        targetModal     : 'js-modal',
        targetModalOpen : 'js-modalOpen',
        targetModalClose: 'js-modalClose',
  
        targetAlign     : 'js-align',
        targetAlignList : [],
        alignAddClass   : 'c-alignheight',
  
        targetOfi       : '.js-ofi .ofi',
  
        targetPagenavi  : 'js-pagenavi',
  
        targetDateField : 'js-datepicker',
  
        targetPullTrg   : 'js-pulldown',
        targetPullConts : 'js-pulldown_conts',
  
        confirmTrg      : 'js-confirmMsg',
  
        alertTrg        : 'js-alertMsg',
  
        removeTrg       : 'js-remove',
  
      };
  
      let alignList = document.querySelectorAll('.' + mod.targetAlign);
      mod.targetAlignList = Array.prototype.slice.call(alignList, 0);
  
      this.iosCheck();
      this.deviceCheck();
      this.smoothScroll();
      // this.tabBtn();
      this.modalBtn();
      this.pulldown();
      this.headerFixed();
      this.confirmMessage();
      this.alertMessage();
  
      objectFitImages(mod.targetOfi);
      Stickyfill.add('.js-sticky');
    },
  
    iosCheck() {
      if ( website.ua.indexOf('ipad') > -1 || website.ua.indexOf('iphone') > -1 || (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document ) ) {
        $('body').addClass('ios');
      } else {
        $('body').removeClass('ios');
      }
    },
  
    deviceCheck() {
      if (
        website.ua.indexOf('iphone') > -1 ||
        website.ua.indexOf('ipod') > -1 ||
        website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1
      ) {
        website.isDesktop = false;
        $('body').removeClass('pc tablet').addClass('sp');
      } else if (
        website.ua.indexOf('ipad') > -1 ||
        website.ua.indexOf('Android') > -1 ||
        (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
      ) {
        website.isDesktop = false;
        $('body').removeClass('pc sp').addClass('tablet');
      } else {
        website.isDesktop = true;
        $('body').removeClass('tablet sp').addClass('pc');
      }
    },
  
    smoothScroll() {
      $('.' + mod.targetSmooth + ':not([href=""])').on('click', function() {
        let href     = $(this).attr("href"),
            target   = $( (href == "#") ? 'html' : href ),
            position;
        if( website.headTag.css('position') == 'fixed' ){
          shift    = ( (href != "#") ) ? website.headTag.outerHeight() : 0
        }else{
          shift    = 50;
        }
        position = target.offset().top - shift;
        $('body,html').animate({scrollTop: position}, mod.smoothSpeed, 'swing');
        return false;
      });
    },
  
    modalBtn() {
      $('.'+mod.targetModalOpen).on('click',function(){
        $('body').addClass('is-modalOpen');
        let target = $(this).attr('href');
        $(target).fadeIn();
        return false;
      });
      $('.'+mod.targetModalClose).on('click',function(){
        $('body').removeClass('is-modalOpen');
        $(this).closest('.'+mod.targetModal).fadeOut();
        return false;
      });
    },
  
    alignHeight() {
      let alignHeight  = 0;
  
      mod.targetAlignList.forEach((target) => {
        target.style.minHeight = 'auto';
        target.classList.add(mod.alignAddClass);
        alignHeight = ( target.offsetHeight > alignHeight ) ? target.offsetHeight: alignHeight;
        target.classList.remove(mod.alignAddClass);
      });
      mod.targetAlignList.forEach((target) => {
        target.style.minHeight = alignHeight + 'px';
      });
    },
  
    pulldown (){
      if(website.winWidth >= website.shiftPoint){
        $('.'+ mod.targetPullTrg).hover(
          function(){
            $(this).addClass('is-act');
            $(this).children('.'+mod.targetPullConts).addClass('is-act').stop().slideDown();
          },
          function(){
            $(this).removeClass('is-act');
            $(this).children('.'+mod.targetPullConts).removeClass('is-act').stop().slideUp();
          }
        )
      } else{
        $('.'+mod.targetPullTrg).children('a').on('click',function(){
          $(this).parent('.'+mod.targetPullTrg).find('.'+mod.targetPullConts).toggleClass('is-act').stop().slideToggle();
          if(!$(this).parent('.'+mod.targetPullTrg).hasClass('is-act')){
            $(this).parent('.'+mod.targetPullTrg).toggleClass('is-act');
            return false;
          }else{
            $(this).parent('.'+mod.targetPullTrg).toggleClass('is-act');
          }
        });
      }
    },
  
    headerFixed (){
      if( website.headTag.css('position') == 'fixed' && $('.js-wrapper').length){
        $('.js-wrapper').css({
          'padding-top' : website.headTag.outerHeight(),
        });
      }
      if(website.scrollY > 0){
        website.headTag.addClass('is-fixed');
      }else{
        website.headTag.removeClass('is-fixed');
      }
    },
  
    confirmMessage() {
      if( $('.' + mod.confirmTrg ).length ){
        $('.' + mod.confirmTrg ).on('click', function(){
          let message = $(this).attr('data-confirm-message'),
              redirect = $(this).attr('data-url');
          let result = window.confirm(message);
  
          if( result ){
            window.location.href = redirect;
          }
        });
      }
    },
  
    alertMessage() {
      if( $('.' + mod.alertTrg ).length ){
        $('.' + mod.alertTrg ).on('click', function(){
          let message = $(this).attr('data-alert-message');
          alert(message);
        });
      }
    },
    removeElement() {
      $('.'+mod.removeTrg).on('click',function(){
        let target = $(this).data('target');
        $(target).remove();
        return false;
      });
    },
  }
  
  const DrawerMenu = {
  
    init() {
      drawer = {
        panel     : 'js-so_panel',
        menu      : 'js-so_menu',
        duration  : 10,
        // openclass : 'slideout-open',
        toggleList: '#js-so_toggle',
        closeList : '#js-so_panel, #js-so_menu .js-scroll',
      };
  
      this.menu();
    },
  
    menu() {
      let slideoutInst = new Slideout({
        'panel': document.getElementById(drawer.panel),
        'menu': document.getElementById(drawer.menu),
        'duration': drawer.duration,
        // 'openclass': drawer.openclass,
      });
  
      let nodeList = document.querySelectorAll(drawer.toggleList);
      let node = Array.prototype.slice.call(nodeList,0);
      node.forEach(function(elem, index){
        elem.addEventListener('click', function() {
          slideoutInst.toggle();
        });
      });
  
      let nodeListClose = document.querySelectorAll(drawer.closeList);
      let nodeClose = Array.prototype.slice.call(nodeListClose,0);
      nodeClose.forEach(function(elem, index){
        elem.addEventListener('click', function() {
          slideoutInst.close();
        });
      });
    },
  
  }
  
    const Animation = {
  
      init() {
      },
  
      check() {
        $('.' + website.targetAnime + ':not(.' + website.actAnime + ')').each(function(){
          let self = $(this),
              targetPosition = self.offset().top,
              triggerPosition,
              shift;
  
          if( website.winWidth < website.shiftPoint ) {
            shift = website.winHeight / website.shiftSp;
          } else {
            shift = website.winHeight / website.shiftPc;
          }
          triggerPosition = targetPosition - website.winHeight + shift;
  
          if( website.scrollY > triggerPosition ){
            self.addClass(website.actAnime);
          }
        });
      },
  
    }
  
  const Slick = {
  
    init() {
      this.topKey();
    },
  
    topKey() {
      if($('.js-kv').length){
        let autospeed = 5000;
        $('.js-kv').slick({
          fade: true,
          autoplay: true,
          autoplaySpeed: autospeed,
          speed: 1000,
          cssEase: 'linear',
          arrows: false,
          dots: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          responsive: [
            {
              // breakpoint: website.breakpoint.ss,
              // settings: {
              //   dots: false,
              // }
  
            },],
        });
      }
    },
  
  }
  
  const Megamenu = {
  
    init() {
      megamenu = {
        wrapElm  : '.js-megaWrap',
        trgElm   : '.js-megaTrg',
        contElm  : '.js-megaCont',
      }
      this.adjust();
      this.action();
    },
    action(){
      if( $(megamenu.trgElm).length && $(megamenu.contElm).length ){
        $(megamenu.trgElm).children('a').on('click',function(){
          if($(this).hasClass('is-act')){
            $(this).removeClass('is-act');
            $(this).siblings(megamenu.contElm).removeClass('is-act').stop().slideUp();
          }else{
            Megamenu.close();
            $(this).addClass('is-act');
            $(this).siblings(megamenu.contElm).addClass('is-act').stop().slideDown();
          }
        });
      }
    },
    close() {
      if( $(megamenu.trgElm).length && $(megamenu.contElm).length ){
        $(megamenu.contElm).removeClass('is-act').stop().slideUp(100).siblings('a').removeClass('is-act');
      }
    },
    adjust() {
      if( $(megamenu.trgElm).length && $(megamenu.contElm).length ){
        let positionY = website.headTag.outerHeight();
        $(megamenu.contElm).css('top', positionY+'px');
      }
    }
  }
  
  const Totop ={
    init(){
      totop = {
        targetClass : '.js-totop',
        speed       : 600,
      }
      if($(totop.targetClass).length){
        this.check();
        this.action();
      }
    },
    check(){
      if( website.scrollY > 100 ){
        $( totop.targetClass ).addClass('is-act').fadeIn(400);
      }else{
        $( totop.targetClass ).removeClass('is-act').fadeOut(400);
      }
    },
    action(){
      $( totop.targetClass ).on('click',function(){
        $('body,html').animate({scrollTop: 0}, totop.speed, 'swing');
        return false;
      });
    }
  }
  
  const Timer = {
    init() {
      timer = {
        targetClass : '.js-timer',
      };
      this.check();
    },
    check() {
      if($(timer.targetClass).length){
        $(timer.targetClass).hide();
        $(timer.targetClass).each(function(){
          let startTime   = new Date($(this).data('start')),
              endTime     = new Date($(this).data('end')),
              currentTime = new Date();
          if(startTime <= currentTime && currentTime <= endTime){
            $(this).show();
            return false;
          }
        });
      }
    }
  }
  
  const Wordpress = {
  
    init() {
      wp = {
        editorTarget: 'js-editor',
        tableClass  : 'c-tbl_responsive',
        tableInnerClass  : 'c-tbl_responsive__inner',
        iframeclass : 'c-iframe',
      }
  
      this.wpEditor();
    },
  
    wpEditor() {
      if ( $(wp.editorTarget).length ) {
        $( '.' + wp.editorTarget + ' table' ).each(function() {
          $(this).wrap('<div class="' + wp.tableClass + '"><div class="' + wp.tableInnerClass + '"></div></div>');
        });
        $( '.' + wp.editorTarget + ' iframe' ).each(function() {
          $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
        });
      }
      // if ( $('.' + wp.editorTarget).length ) {
      //   $( '.' + wp.editorTarget + ' table' ).each(function() {
      //     $(this).wrap('<div class="' + wp.tableClass + '"></div>');
      //   });
      //   $( '.' + wp.editorTarget + ' iframe' ).each(function() {
      //     $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
      //   });
      // }
    }
  
  }
  
  const Accordion = {
  
    init() {
      accordion = {
        toggleElm : '.js-accordion',
        openElm   : '.js-accordionOpen',
        closeElm   : '.js-accordionClose',
      };
      this.toggle();
      this.open();
      this.close();
    },
  
    toggle() {
      if($(accordion.toggleElm).length){
        $(accordion.toggleElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          if( target && $(target).length){
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act);
              $(target).stop().slideUp('fast');
              return false;
            } else {
              $(this).addClass(website.act);
              $(target).stop().slideDown();
              return false;
            }
          }else{
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act).next().stop().slideUp('fast');
            } else {
              $(this).addClass(website.act).next().stop().slideDown();
            }
          }
        });
      }
    },
    open() {
      if($(accordion.openElm).length){
        $(accordion.openElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          if( target && $(target).length){
            if ( !$(this).hasClass(website.act) ) {
              $(this).addClass(website.act);
              $(target).stop().slideDown();
              $(this).hide();
              return false;
            }
          }else{
            if ( !$(this).hasClass(website.act) ) {
              $(this).addClass(website.act);
              $(this).addClass(website.act).next().stop().slideDown();
              $(this).hide();
            }
          }
        });
      }
    },
    close() {
      if($(accordion.closeElm).length){
        $(accordion.closeElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          if( target && $(target).length){
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act);
              $(target).stop().slideUp('fast');
              $(this).hide();
              return false;
            }
          }else{
            if ( !$(this).hasClass(website.act) ) {
              $(this).removeClass(website.act).next().stop().slideUp('fast');
              $(this).hide();
            }
          }
        });
      }
    }
  
  }
  


  // OFF
  // ./inc/_loading.js
  // ./inc/_pagescroll.js
  // ./inc/_parallax.js
  // ./inc/_form.js
  // ./inc/_favorite.js


  // page
  const BasicPage = {
    init() {
      basic = {};
    },
  
    update() {
    },
  }
  
  const TopPage = {
    init() {
      page.top = {
        loadingElm    : '.js-homeLoading',
        loadingImgElm    : '.js-homeLoadingImg',
        loadingCoverElm    : '.js-homeLoadingCover',
        wrapElm       : '.js-homeContainer',
        sectionElm    : '.js-homeSection',
        navElm        : '.js-homeNavi',
        loader        : '.js-homeLoader',
        logoElm       : '.js-logo',
        moveFlag      : true,
        sectionCount  : 0,
        prevCount     : 0,
        nextCount     : 0,
        duration      : 1500,
      }
      $(page.top.wrapElm).css({
        'width'   : website.winWidth,
        'height'  : website.winHeight
      })
      iNoBounce.enable();
      this.loading();
      this.generate();
      if ((website.ua.indexOf('iphone') > 0 && website.ua.indexOf('ipad') === -1) || (website.ua.indexOf('ipad') > 0 || website.ua.indexOf('macintosh') > 0 && 'ontouchend' in document ) || website.ua.indexOf('ipod') > 0 || website.ua.indexOf('android') > 0) {
        this.spMethod();
        
      }else{
        this.pcMethod();
      }
      this.navAction();
    },
    loading(){
      if($(page.top.loadingElm).length){
        $(page.top.loadingImgElm).velocity({
          scale: 0,
          opacity: 0,
        },{
          duration:0,
          begin: function(){
            $(page.top.loadingCoverElm).velocity({
              scaleX: 1,
              skewX: '-15deg',
            },{
              duration: 0,
            })
          },
        }).velocity({
          scale: 1,
          opacity: 1,
        },{
          duration : 2500,
          complete: function(){
            $(this).delay(500).fadeOut(100,function(){
              $(page.top.loadingCoverElm).velocity({
                left: '-50%',
              },{
                delay: 500,
                duration: 500,
                complete: function(){
                  $(this).velocity({
                    scaleX: 0,
                  },{
                    dulation: 500,
                    begin : function(){
                      $(page.top.loadingElm).css({
                        'background': '#000',
                      });
                    },
                    complete : function(){
                      $(page.top.loadingElm).delay(500).fadeOut(300,function(){
                        page.top.moveFlag  = false;
                        $(this).css({
                          'visibility': 'hidden',
                        });
                        if($(page.top.sectionElm+'[data-section-count="0"]').find('video').length){
                          let video = $(page.top.sectionElm+'[data-section-count="0"]').find('video').get(0);
                          video.currentTime = 0;
                          video.play();
                        }
                      });
                    }
                  })
                }
              });
            });
          },
        })
      }
    },
    generate() {
      $(page.top.wrapElm).attr('data-section',page.top.sectionCount).children(page.top.sectionElm).each(function(){
        let index = $(page.top.sectionElm).index(this);
        $(this).attr('data-section-count',index);
        $('<a></a>').attr('href','javascript:void(0)').attr('data-target-section',index).appendTo($(page.top.navElm));
      });
      $(page.top.sectionElm+'[data-section-count="0"]').addClass('is-act').css({
        'visibility': 'visible',
        'opacity'   : 1,
      });
      $(page.top.navElm).children('a[data-target-section="0"]').addClass('is-act');
    },
    pcMethod() {
      window.addEventListener('wheel', function(e){
        if(!page.top.moveFlag){
          if(e.deltaY > 0){
            TopPage.update('addition');
          }else if(e.deltaY < 0){
            TopPage.update('subtraction');
          }
        }
      });
  
    },
    spMethod(){
      let touchStart, touchMove, touchDistance;
  
      window.addEventListener('touchstart',function(e){
        touchStart = e.touches[0].pageY;
        touchMove  = e.touches[0].pageY;
      });
  
      window.addEventListener('touchmove',function(e){
        touchMove = e.touches[0].pageY;
      });
  
      window.addEventListener('touchend',function(e){
        touchDistance = touchStart - touchMove;
        if(touchDistance > 25){
          TopPage.update('addition');
        }else if(touchDistance < -25){
          TopPage.update('subtraction');
        }
      });
    },
    navAction() {
      $(document).on('click',page.top.navElm +' a', function(){
        let target = $(this).data('target-section');
        TopPage.update('direct', target);
      });
    },
    logoStatus(element) {
      let statusH,statusV;
      statusH = element.data('horizontal-logo');
      statusV = element.data('vertical-logo');
      $(page.top.logoElm).attr('data-horizontal-logo', statusH).attr('data-vertical-logo',statusV);
  
    },
    move(method) {
      page.top.moveFlag = true;
      let targetElm,currentElm, move = {duration: 1500}, size ={duration : 500, value: '90%'} ;
      $(page.top.navElm).children().removeClass('is-act');
      $(page.top.navElm).find('[data-target-section="'+page.top.nextCount+'"]').addClass('is-act');
      targetElm = $(page.top.sectionElm+'[data-section-count="'+page.top.nextCount+'"]');
      currentElm = $(page.top.sectionElm+'[data-section-count="'+page.top.sectionCount+'"]');
      currentElm.removeClass('is-act');
      $(page.top.navElm).addClass('is-act');
      TopPage.logoStatus(targetElm);
      switch(method){
        case 'up':
          move.init ={
            posX  : '-150%',
            posY  : '150%',
          }
          currentElm.velocity({
            scale: size.value,
          },{
            duration : size.duration,
            easing: 'ease-in',
            begin    : function(){
              if(currentElm.find('video').length){
                let video = currentElm.find('video').get(0);
                video.pause();
              }
              targetElm.velocity({
                translateX : move.init.posX,
                translateY : move.init.posY,
              },{
                duration : 0,
                complete: function(){
                  targetElm.css({
                    'visibility': 'visible',
                    'opacity'   : 1,
                  });
                }
              }).velocity({
                scale: size.value,
              },{
                duration : size.duration,
                easing: 'ease-in',
              });
            },
          }).velocity({
            translateX : '150%',
            translateY : '-150%',
          },{
            duration : move.duration,
            easing: 'ease-in-out',
            begin    : function(){
              targetElm.velocity({
                translateX : '0%',
                translateY : '0%',
              },{
                duration : move.duration,
                easing: 'ease-in-out',
              });
            },
          }).velocity({
            scale: '100%',
          },{
            duration : size.duration,
            easing: 'ease-out',
            begin    : function(){
              targetElm.velocity({
                scale: '100%',
              },{
                duration : size.duration,
                easing: 'ease-out',
                complete: function(){
                  targetElm.addClass('is-act');
                  if(targetElm.find('video').length){
                    let video = targetElm.find('video').get(0);
                    video.currentTime = 0;
                    video.play();
                  }
                  page.top.prevCount = page.top.sectionCount
                  page.top.sectionCount = page.top.nextCount;
                  page.top.moveFlag = false;
                }
              });
            },
            complete: function(){
              $(page.top.navElm).removeClass('is-act');
              currentElm.css({
                'visibility': 'hidden',
                'opacity'   : 0,
              });
            }
          });
        break;
        case 'down':
          move.init ={
            posX  : '150%',
            posY  : '-150%',
          }
          currentElm.velocity({
            scale: size.value,
          },{
            duration : size.duration,
            easing: 'ease-in',
            begin    : function(){
              if(currentElm.find('video').length){
                let video = currentElm.find('video').get(0);
                video.pause();
              }
              targetElm.velocity({
                translateX : move.init.posX,
                translateY : move.init.posY,
              },{
                duration : 0,
                complete: function(){
                  targetElm.css({
                    'visibility': 'visible',
                    'opacity'   : 1,
                  });
                }
              }).velocity({
                scale: size.value,
              },{
                duration : size.duration,
                easing: 'ease-in',
              });
            },
          }).velocity({
            translateX : '-150%',
            translateY : '150%',
          },{
            duration : move.duration,
            easing: 'ease-in-out',
            begin    : function(){
              targetElm.velocity({
                translateX : '0%',
                translateY : '0%',
              },{
                duration : move.duration,
                easing: 'ease-in-out',
              });
            },
          }).velocity({
            scale: '100%',
          },{
            duration : size.duration,
            easing: 'ease-out',
            begin    : function(){
              targetElm.velocity({
                scale: '100%',
              },{
                duration : size.duration,
                easing: 'ease-out',
                complete: function(){
                  targetElm.addClass('is-act');
                  if(targetElm.find('video').length){
                    let video = targetElm.find('video').get(0);
                    video.currentTime = 0;
                    video.play();
                  }
                  page.top.prevCount = page.top.sectionCount
                  page.top.sectionCount = page.top.nextCount;
                  page.top.moveFlag = false;
                }
              });
            },
            complete: function(){
              $(page.top.navElm).removeClass('is-act');
              currentElm.css({
                'visibility': 'hidden',
                'opacity'   : 0,
              });
            }
          });
        break;
      }
    },
    update(method,count = 0) {
      let current = page.top.sectionCount;
      switch(method){
        case 'addition':
          current++;
          if(current < $(page.top.wrapElm).children().length){
            page.top.nextCount = current;
            TopPage.move('up');
          }
        break;
        case 'subtraction':
          current--;
          if(current >= 0){
            page.top.nextCount = current;
            if($(page.top.sectionElm).eq(page.top.nextCount).data('section-name') == 'business'){
              $(page.top.logoElm).hide();
            }else{
              $(page.top.logoElm).show();
            }
            TopPage.move('down');
          }
        break;
        case 'direct':
          if($(page.top.sectionElm+'[data-section-count="'+count+'"]').length){
            page.top.nextCount = count;
            if(page.top.nextCount > page.top.sectionCount){
              TopPage.move('up');
            }else{
              TopPage.move('down');
            }
          }
        break;
      }
    },
    resize(){
      if($(page.top.wrapElm).length){
        $(page.top.wrapElm).css({
          'width': website.winWidth,
          'height': website.winHeight
        })
      }
      if($(page.top.sectionElm)){
        $(page.top.sectionElm).css({
          'padding-top' : website.headTag.outerHeight(),
        });
      }
    }
  }
  



  const App = {

    init() {
      if ( website.page != 'wp-manual' && website.page != 'wp-manual-single' ) {
        this.set();
        // this.update();
      } else {
        // Modules.init();
        // Wordpress.init();
      }
    },

    set() {
      Modules.init();
      DrawerMenu.init();
      Wordpress.init();
      // Animation.init();
      // PageScroll.init();
      // Parallax.init();
      Slick.init();


      if ( website.page == 'top' ) {
        TopPage.init();
        WinLoad.add( TopPage.resize );
        WinResize.add( TopPage.resize );
        console.log(website.page)
      } else if( website.page  == 'contact' ) {
        Form.init();
      }

      WinLoad.add( Modules.headerFixed );
      WinLoad.add( Animation.check );
      // WinLoad.add( Modules.megaMenu );
      // WinLoad.add( Iscroll.check );

      WinResize.add( Modules.iosCheck );
      WinResize.add( Modules.deviceCheck );
      WinResize.add( Modules.headerFixed );

      WinScroll.add( Animation.check );
      // WinScroll.add( Totop.check );
      // WinScroll.add( Iscroll.check );


      WinLoad.init();
      WinResize.init();
      WinScroll.init();

    },

    // update() {
    //   website.animationFrame = window.requestAnimationFrame( App.update );
    //   website.winWidth       = window.innerWidth;
    //   website.winHeight      = window.innerHeight;
    //   website.scrollY        = window.pageYOffset;

    //   if ( website.isDesktop ) {
    //     PageScroll.smooth();

    //     if ( website.page == 'top' ) {
    //       Parallax.moveImg();
    //     }
    //   }
    // },

  }


  App.init();

})();


})(jQuery);
